import React from 'react';
import EndedActions from "@components/views/StartPage/ActionsList/EndedActions/Main";

const EndedActionsContainer = (props) => {
    return (
        <EndedActions {...props}/>
    );
}

export default EndedActionsContainer;